import { DatePipe } from '@angular/common';
import { Component, Injector, Input, OnInit } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';

@Component({
    templateUrl: './footer.component.html',
    selector: 'footer-bar',
    imports: [DatePipe]
})
export class FooterComponent extends AppComponentBase implements OnInit {

    today = new Date();
    releaseDate: string;

    @Input() useWrapperDiv = false;
    @Input() useBottomDiv = true;

    constructor(
        injector: Injector
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.releaseDate = this.appSession.application.releaseDate.toFormat('YYYYMMDD');
    }
}
